import "@fontsource/geist";
import "./globals.css";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	enabled: import.meta.env.MODE === "production",
	tracesSampleRate: 0.2,
	replaysSessionSampleRate: 0,
	replaysOnErrorSampleRate: 0,
	debug: false,
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("root element not found");

createRoot(rootEl).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
